import React from "react";
import XAxisZoomUpImage from "./img/xzoomup.png";
import XAxisZoomOutImage from "./img/xzoomout.png";
import YAxisZoomUpImage from "./img/yzoomup.png";
import YAxisZoomOutImage from "./img/yzoomout.png";
import "./icon.css";

/**
 * チャートX軸拡大アイコンを表示します
 * @returns チャートX軸拡大アイコン
 */
export function ChartXAxisZoomUpIcon() {
  return <img className="chart-dialog" src={XAxisZoomUpImage} alt="xzoomup" />;
}

/**
 * チャートX軸縮小アイコンを表示します
 * @returns チャートX軸縮小アイコン
 */
export function ChartXAxisZoomOutIcon() {
  return (
    <img className="chart-dialog" src={XAxisZoomOutImage} alt="xzoomout" />
  );
}

/**
 * チャートY軸拡大アイコンを表示します
 * @returns チャートY軸拡大アイコン
 */
export function ChartYAxisZoomUpIcon() {
  return <img className="chart-dialog" src={YAxisZoomUpImage} alt="yzoomup" />;
}

/**
 * チャートY軸縮小アイコンを表示します
 * @returns チャートY軸縮小アイコン
 */
export function ChartYAxisZoomOutIcon() {
  return (
    <img className="chart-dialog" src={YAxisZoomOutImage} alt="yzoomout" />
  );
}
